import DownloadLink from '@Components/Utility/DownloadLink'
import { getRateSheetDownloadUrl } from '@App/api/routes/rightsholder/statements'
import React from 'react'
import { RateSheetLink } from '@Entities/statements/rate-sheet-link'
import './index.scss'
import Status from '@Components/Status'

interface RightsholderRateSheetDownloadLinkProps {
    rateSheetLink: RateSheetLink
    status: 'provisional' | 'original' | 'adjusted'
}

const RightsholderRateSheetDownloadLink = ({ rateSheetLink, status }: RightsholderRateSheetDownloadLinkProps) => {
    const fetchDownloadLink = async (rate: RateSheetLink) =>
        getRateSheetDownloadUrl(rate.rateSheetLink.substring(1)).then((response) =>
            Promise.resolve(response.data.rateSheetURL)
        )
    return (
        <div className="rate-sheet-download-link">
            <DownloadLink
                fetchLink={() => fetchDownloadLink(rateSheetLink)}
                text={`Download${status === 'original' ? ' Original' : ''}`}
            />
            {status === 'provisional' && <Status status="provisional" circleFirst />}
        </div>
    )
}

export default RightsholderRateSheetDownloadLink
